import { message } from 'antd'
import qs from 'qs'

import { apiDomain, version } from './config'

interface CustomError {
  flag: number
  message: string
}

export default async function fetchJson<JSON = unknown>(
  url: string,
  params: Record<string, unknown> = {}
) {
  const token = localStorage.getItem('pc_app_token')

  if (token) {
    params.key = token
  }

  const res = await fetch(
    apiDomain + url + '?' + qs.stringify(params) + `&version=${version}`
  )
  const { flag, data, msg } = await res.json()

  if (flag !== 200) {
    const error: CustomError = {
      flag: flag,
      message: msg || '服务器开小差',
    }

    if (flag === 401) {
      message.error('登录状态已过期，请重新登录')
      localStorage.removeItem('pc_app_token')
      localStorage.removeItem('fList')
      localStorage.removeItem('sList')
      localStorage.removeItem('success')
    }

    throw error
  }

  return data as JSON
}
